<div class="change-outlet-wrap">
  <ng-container *ngIf="!!customComponentForChangeOutlet(); else coreChangeOutlet">
    <div [loadComponent]=customComponentForChangeOutlet()
         [inputs]="{
          mobile: mobile,
          isLoginSuperBusinessAdminOrBusinessAdmin: isLoginSuperBusinessAdminOrBusinessAdmin
         }"
         [outputs]="{closeAction}">
    </div>
  </ng-container>
  <ng-template #coreChangeOutlet>
    <app-change-outlet-core
      [mobile]="mobile"
      [isLoginSuperBusinessAdminOrBusinessAdmin]=" isLoginSuperBusinessAdminOrBusinessAdmin"
      (closeAction)="closeAction.emit($event)"
    >
    </app-change-outlet-core>
  </ng-template>
</div>
